import { AnnotationStatus } from '@rossum/api-client/shared';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { DocumentStatus } from '../../../components/UI/DocumentStatus';

const RenderStatus = (
  props: GridRenderCellParams<
    {
      modifier:
        | {
            id: number;
            username: string;
          }
        | string;
      restricted_access?: boolean;
      workflow_step?: string;
    },
    AnnotationStatus
  >
) => {
  const {
    value: status,
    row: { modifier, restricted_access, workflow_step },
  } = props;

  return (
    <DocumentStatus
      status={status}
      modifier={modifier}
      workflowStepName={workflow_step}
      disabled={restricted_access}
    />
  );
};

export { RenderStatus };
